import {createAudioContext} from "./TextToSpeechUtilsPoly";
import {Queue} from "../contexts/Queue";


export class AudioInputHandler {
    private audioContext: AudioContext;
    private source: MediaStreamAudioSourceNode;
    private currentGainNode: GainNode;
    private mediaStream: MediaStream;       // output (destination) stream
    private inputStream: MediaStream;       // original getUserMedia stream
    // AEC setting the capture was created with; fixed for the lifetime of the stream
    private readonly echoCancellation: boolean;

    constructor(deviceId: string, gain: number, stream: MediaStream, echoCancellation: boolean = false) {
        this.echoCancellation = echoCancellation;
        this.audioContext = createAudioContext(deviceId, 'audioinput') as AudioContext;

        void this.ensureContextResumed();

        this.inputStream = stream;
        this.source = this.audioContext.createMediaStreamSource(stream);

        this.currentGainNode = this.audioContext.createGain();
        this.currentGainNode.gain.value = gain;
        this.source.connect(this.currentGainNode);

        const destination = this.audioContext.createMediaStreamDestination();
        this.currentGainNode.connect(destination);

        this.mediaStream = destination.stream;
    }

    private async ensureContextResumed() {
        if (this.audioContext.state === 'suspended') {
            try {
                await this.audioContext.resume();
            } catch {
            }
        }
    }

    public setVolume(gain: number): void {
        this.ensureContextResumed()
            .then(_ => {
                if (this.currentGainNode) {
                    this.currentGainNode.gain.value = gain;
                }
            }).catch(error => console.log('[AudioInputHanlders] err', error));
    }

    public getEchoCancellation(): boolean {
        return this.echoCancellation;
    }

    public getAudioStream(): MediaStream {
        this.ensureContextResumed()
            .catch(error => console.log('[AudioInputHanlders] err', error));
        return this.mediaStream;
    }

    /**
     * The original getUserMedia stream, before the gain node. Consumers that need an
     * independent copy of the capture (e.g. the Two-Way Floor Feed) clone tracks from
     * this stream instead of opening a second getUserMedia on the same device.
     */
    public getRawStream(): MediaStream {
        return this.inputStream;
    }

    public stop() {
        try {
            this.currentGainNode?.disconnect();
        } catch {
        }
        try {
            this.source?.disconnect();
        } catch {
        }
        // Stop original mic tracks
        try {
            this.inputStream?.getTracks().forEach(t => t.stop());
        } catch {
        }
        // Close AudioContext
        try {
            this.audioContext.close();
        } catch {
        }
        try {
            this.mediaStream?.getTracks().forEach(track => track.stop());
        } catch {
        }
    }
}